import PasswordInput from '@components/TextInput/PasswordInput';
import TextInput from '@components/TextInput/TextInput';

export const loginConfig = [
  {
    name: 'email',
    label: 'SignIn.emailUserName',
    component: TextInput,
    required: true,
    sm: 12,
    margin: 'normal',
    isIcon: false
  },
  {
    name: 'password',
    label: 'SignIn.password',
    component: PasswordInput,
    required: true,
    sm: 12,
    margin: 'normal'
  }
];
